// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".all-tests[data-v-d81b4350] {\n  display: flex;\n  flex-wrap: wrap;\n}\n.all-tests .each-test[data-v-d81b4350] {\n  width: 33.33%;\n}\n.all-tests .each-test .each-check-box .el-checkbox[data-v-d81b4350] {\n  display: flex;\n  align-items: flex-start;\n}\n.all-tests .each-test .each-check-box .el-checkbox__label[data-v-d81b4350] {\n  white-space: normal;\n}\n.all-tests .each-test .each-check-box[data-v-d81b4350]:not(:last-child) {\n  margin-bottom: 10px !important;\n}", ""]);
// Exports
module.exports = exports;
